import React from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames';
import { FiDownload } from 'react-icons/fi';
import { FormattedMessage } from '../../util/reactIntl';
import { PrimaryButton } from '../Button/Button';
import IconSpinner from '../IconSpinner/IconSpinner';
import { RECEIPT_KIND } from '../../util/receipts/eligibility';

import css from './TransactionPanel.css';

// "Download receipt" / "Download billing basis" under a completed process
// step (downloadable receipts spec §7), styled like the card's step actions.
// The PDF is generated on every click, which takes a few seconds: spinner and
// disabled until it arrives, keeping the label so the button doesn't shrink.
const ReceiptButton = ({ kind, onDownload, inProgress, failed }) => {
  if (!kind) return null;
  const labelId =
    kind === RECEIPT_KIND.PROVIDER_BILLING_BASIS
      ? 'ProcessSteps.downloadBillingBasis'
      : 'ProcessSteps.downloadReceipt';
  return (
    <div className={css.stepAction}>
      <PrimaryButton
        type="button"
        className={classNames(css.openCustomOfferModalButton, css.receiptButton)}
        onClick={onDownload}
        disabled={inProgress}
        aria-busy={inProgress}
      >
        {inProgress ? (
          <IconSpinner rootClassName={css.receiptButtonSpinner} />
        ) : (
          <FiDownload className={css.receiptButtonIcon} aria-hidden="true" />
        )}
        <FormattedMessage id={labelId} />
      </PrimaryButton>
      {failed ? (
        <p className={css.receiptButtonError} role="alert">
          <FormattedMessage id="ProcessSteps.receiptDownloadFailed" />
        </p>
      ) : null}
    </div>
  );
};

ReceiptButton.defaultProps = { kind: null, inProgress: false, failed: false };

ReceiptButton.propTypes = {
  kind: string,
  onDownload: func.isRequired,
  inProgress: bool,
  failed: bool,
};

export default ReceiptButton;
